module.exports = __webpack_public_path__ + "48d703fbc1d1557e3d5c608ca3aa1492.pdf";